module.exports = __webpack_public_path__ + "img/hm.1ba5f94.svg";